/**
 * Hook to track AI activity across all users
 */

import { useState, useEffect } from 'react';
import { subscribeToAIActivity } from '../services/aiPresence';
import { useAuth } from './useAuth';

export function useAIActivity() {
  const { currentUser } = useAuth();
  const [aiActivity, setAIActivity] = useState([]);

  useEffect(() => {
    const unsubscribe = subscribeToAIActivity((activity) => {
      // Filter out current user's own activity
      const othersActivity = activity.filter(a => a.userId !== currentUser?.uid);
      setAIActivity(othersActivity);
    });

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [currentUser]);

  return aiActivity;
}


